/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import EmailTemplatePicker from 'shared/ui/components/form-components/pickers/EmailTemplatePicker.vue';
import InputWithUnit from 'shared/ui/components/form-components/InputWithUnit.vue';
import { get } from 'lodash';

const __vue_script__ = {
    name: 'Waitlist',

    components: {
        EmailTemplatePicker,
        InputWithUnit
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        registry: {
            type: Object,
            required: true
        },

        value: {
            type: Object,
            required: true
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            available_seat_email: null,
            lease_time: 24,
            unclaimed_seat_email: null
        };
    },

    watch: {
        lease_time() {
            this.emit();
        },

        disabled(value) {
            if (value === false) {
                this.init();
            }
        }
    },

    created() {
        this.init();
    },

    methods: {
        /**
         * Initializes the component.
         */
        init() {
            const waitlist = this.registry.settings.waitlist || {};
            this.lease_time = this.value.lease_time || waitlist.lease_time?.default;
            this.available_seat_email = this.value.available_seat_email;
            this.unclaimed_seat_email = this.value.unclaimed_seat_email;
        },

        /**
         * Emits the component's value.
         *
         * @emits input - The emitted event.
         */
        emit() {
            this.$emit('input', {
                available_seat_email: this.available_seat_email,
                lease_time: this.lease_time,
                unclaimed_seat_email: this.unclaimed_seat_email
            });
        },

        /**
         * Retrieves the label for a given registry field.
         *
         * @param {string} field - The field to retrieve the label for.
         *
         * @returns {string} The label for the specified field.
         */
        getRegistryLabel(field) {
            return this.getLabel(field, 'label');
        },

        /**
         * Retrieves the hint label for a given field.
         *
         * @param {string} field - The field for which to retrieve the hint label.
         *
         * @returns {string} The hint label for the specified field.
         */
        getHintLabel(field) {
            return this.getLabel(field, 'hint');
        },

        /**
         * Retrieves the label for a given field and scope.
         *
         * @param {string} field - The field to retrieve the label for.
         * @param {string} scope - The scope of the field.
         *
         * @returns {string} The label for the specified field and scope.
         */
        getLabel(field, scope) {
            const tKey = get(this.registry, `settings.waitlist.${field}.${scope}`);
            return this.$te(tKey) ? this.$t(tKey) : field;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waitlist" },
    [
      _c("p", { staticClass: "intro" }, [
        _vm._v(
          _vm._s(_vm.$t("registration.sessions_configuration.waitlist_intro"))
        ),
      ]),
      _c("validation-provider", {
        attrs: { slim: true, name: "lease_time", rules: "required|min:1" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c(
                  "input-with-unit",
                  {
                    staticClass: "small-input",
                    attrs: {
                      errors: errors,
                      disabled: _vm.disabled,
                      label: _vm.getRegistryLabel("lease_time"),
                      min: 1,
                      name: "lease_time",
                      type: "number",
                    },
                    model: {
                      value: _vm.lease_time,
                      callback: function ($$v) {
                        _vm.lease_time = $$v
                      },
                      expression: "lease_time",
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("general_settings.form.hours"))),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { slim: true, name: "available_seat_email" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("email-template-picker", {
                  attrs: {
                    errors: errors,
                    "event-id": _vm.event._id,
                    disabled: _vm.disabled,
                    "hint-after-label": true,
                    hint: _vm.getHintLabel("available_seat_email"),
                    label: _vm.getRegistryLabel("available_seat_email"),
                    "show-no-send": true,
                    name: "available_seat_email",
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.available_seat_email,
                    callback: function ($$v) {
                      _vm.available_seat_email = $$v
                    },
                    expression: "available_seat_email",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { slim: true, name: "unclaimed_seat_email" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("email-template-picker", {
                  attrs: {
                    errors: errors,
                    "event-id": _vm.event._id,
                    disabled: _vm.disabled,
                    "hint-after-label": true,
                    hint: _vm.getHintLabel("unclaimed_seat_email"),
                    label: _vm.getRegistryLabel("unclaimed_seat_email"),
                    "show-no-send": true,
                    name: "unclaimed_seat_email",
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.unclaimed_seat_email,
                    callback: function ($$v) {
                      _vm.unclaimed_seat_email = $$v
                    },
                    expression: "unclaimed_seat_email",
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/session-registration/settings/Waitlist.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__